import type { JSX } from 'react'
import { api, call } from '@/api/client'
import type { Schema } from '@/api/client'
import { useMutation, useQuery } from '@/api/query'
import { ContentQualityForm } from '@/settings/content-quality/form'
import { ErrorState, Loading } from '@/ui/states'
import { SettingsStepShell } from './SettingsStepShell'
import { useSettleStep } from './settingsStep'

/** Step 12 — the quality gate, through `/settings/content-quality`'s form. */
export function ContentQualityStep(): JSX.Element {
  const limits = useQuery(
    (signal) => call(() => api.GET('/api/v1/seo/content/quality', { signal })),
    [],
  )
  const save = useMutation((body: Schema<'QualityThresholdsIn'>) =>
    call(() => api.PUT('/api/v1/seo/content/quality', { body })),
  )
  const { settle, failure } = useSettleStep('content_quality')

  return (
    <SettingsStepShell step="content_quality" failure={failure}>
      {limits.state.status === 'loading' ? <Loading label="Loading" lines={2} /> : null}
      {limits.state.status === 'error' ? (
        <ErrorState failure={limits.state.failure} onRetry={limits.refetch} />
      ) : null}
      {limits.state.status === 'ready' ? (
        <ContentQualityForm
          stored={limits.state.data}
          submitLabel="Continue"
          onSubmit={async (body) => {
            const result = await save.run(body)
            if (result.ok) await settle()
            return result
          }}
        />
      ) : null}
    </SettingsStepShell>
  )
}
